import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/dashboard/listings/")({
  head: () => routeHead("/dashboard/listings/"),
  beforeLoad: () => {
    throw redirect({ href: "/my-listings-v2", statusCode: 301, replace: true });
  },
});
